import React, { useState } from 'react';
import { useProjectStore } from '../../stores/projectStore';
import { Dialog } from '../common/Dialog';
import { Button } from '../common/Button';
import * as styles from './NewWorkspaceDialog.css.ts';

interface NewWorkspaceDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NewWorkspaceDialog: React.FC<NewWorkspaceDialogProps> = ({ isOpen, onClose }) => {
  const [workspaceName, setWorkspaceName] = useState('');
  const createWorkspace = useProjectStore((state) => state.createWorkspace);
  const switchWorkspace = useProjectStore((state) => state.switchWorkspace);

  const handleCreate = () => {
    if (!workspaceName.trim()) return;

    const newWorkspaceId = createWorkspace({
      name: workspaceName.trim(),
    });

    switchWorkspace(newWorkspaceId);
    handleClose();
  };

  const handleClose = () => {
    setWorkspaceName('');
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Create New Workspace"
      width="md"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleCreate}
            disabled={!workspaceName.trim()}
          >
            Create Workspace
          </Button>
        </>
      }
    >
      <div className={styles.form}>
        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="workspace-name">Workspace Name</label>
          <input
            className={styles.input}
            id="workspace-name"
            type="text"
            value={workspaceName}
            onChange={(e) => setWorkspaceName(e.target.value)}
            placeholder="Enter workspace name"
            aria-label="Workspace Name"
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleCreate();
            }}
          />
        </div>
      </div>
    </Dialog>
  );
};